import { Avatar, Box, Button, ListItem, UnorderedList } from "@chakra-ui/react";
import React, { useState } from "react";
import { SearchInput } from "../../components/SearchInput";

export const SideList = ({
  listItems = [],
  onSelect,
  searchLabel,
  type = "studentList",
  isFocusedId = "",
}) => {
  const [searchText, setSearchText] = useState("");

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };
  return (
    <Box
      style={{
        maxWidth: "300px",
        width: "100%",
        padding: "30px 0 0 0",
      }}
    >
      <SearchInput
        maxWidth="300px"
        value={searchText}
        placeholder={searchLabel}
        onSearch={onSearch}
      />
      <UnorderedList
        style={{
          margin: "0",
          padding: "10px 0",
        }}
      >
        {React.Children.toArray(
          listItems
            ?.filter((listItem) =>
              searchText !== ""
                ? listItem?.name?.toLowerCase()?.includes(searchText)
                : true
            )
            ?.map((listItem, index) => (
              <ListItem
                style={{
                  listStyle: "none",
                }}
              >
                <Button
                  variant="ghost"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    margin: "0 0 10px",
                    borderRadius: "36px 0px 0px 36px",
                    padding: "25px 10px",
                  }}
                  _active={{
                    background: "rgba(0, 176, 255, 0.2)",
                  }}
                  _focus={{
                    background: "rgba(0, 176, 255, 0.2)",
                  }}
                  _hover={{
                    background: "rgba(0, 176, 255, 0.2)",
                  }}
                  background={
                    listItem.id === isFocusedId ? "rgba(0, 176, 255, 0.2)" : ""
                  }
                  onClick={() => {
                    onSelect(listItem.id);
                  }}
                >
                  {type === "studentList" && (
                    <Avatar
                      size="sm"
                      name={listItem?.name}
                      src={listItem?.userPicture}
                      marginRight="10px"
                    />
                  )}
                  <Box as="span">
                    {type !== "studentList" ? `${index + 1}.` : ""}{" "}
                    {listItem?.name}
                  </Box>
                </Button>
              </ListItem>
            ))
        )}
      </UnorderedList>
    </Box>
  );
};
